import {
  useAudioWaveform,
  useTracks,
  AudioTrack,
  type TrackReferenceOrPlaceholder,
  AgentState,
} from '@livekit/components-react';
import { Track } from 'livekit-client';

function Orb({ state, trackRef }: { state: AgentState; trackRef?: TrackReferenceOrPlaceholder }) {
  const { bars } = useAudioWaveform(trackRef);

  const bgColors =
    state === 'speaking'
      ? 'from-pink-400 to-fuchsia-700'
      : state !== 'disconnected'
        ? 'from-sky-200 via-blue-400 to-indigo-900'
        : 'from-white to-gray-900';

  const maxBar = Math.max(...bars, 1);
  const normalizedBars = bars.map((bar) => bar / maxBar);
  const averageVolume = normalizedBars.reduce((a, b) => a + b, 0) / normalizedBars.length;
  const scale = 0.9 + averageVolume * 0.3;

  return (
    <div class="relative flex items-center justify-center">
      <div
        class={`size-16 rounded-full bg-radial-[at_50%_75%] transition duration-75 ${bgColors} ${state === 'speaking' ? 'animate-orb' : ''}`}
        style={{ transform: state === 'speaking' ? 'scale(1.2)' : `scale(${scale})` }}
      />
    </div>
  );
}

export function OrbWithAudio({ state, isMuted }: { state: AgentState; isMuted: boolean }) {
  const tracks = useTracks([Track.Source.Microphone]);
  const agentTrack = tracks.find((t) => t.participant.isAgent);
  const localTrack = tracks.find((t) => !t.participant.isAgent);

  const trackToUse = state === 'speaking' ? agentTrack : isMuted ? undefined : localTrack;

  return (
    <>
      {agentTrack && <AudioTrack trackRef={agentTrack} />}
      <Orb state={state} trackRef={trackToUse} />
    </>
  );
}
